import { render, staticRenderFns } from "./readwindow.vue?vue&type=template&id=62303064&scoped=true"
import script from "./readwindow.vue?vue&type=script&lang=js"
export * from "./readwindow.vue?vue&type=script&lang=js"
import style0 from "./readwindow.vue?vue&type=style&index=0&id=62303064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62303064",
  null
  
)

export default component.exports